import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import { ADMIN_GIAO_VIEC_PREFIX_URL } from './constants/config.admin-giao-viec'

const ListPageAdminGiaoViec = lazy(
  () => import('./pages/ListPage.AdminGiaoViec')
)

const AdminGiaoViecRouters: AppRouterItem[] = [
  {
    path: `${ADMIN_GIAO_VIEC_PREFIX_URL}/`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageAdminGiaoViec />
      </LoadingLazyComponents>
    ),
  },
]

export default AdminGiaoViecRouters
